/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  ProductListingHeader.tsx
*
* Project Title :  Checkout
*
* Description	: Purchase Software page
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H175591
*
* @Date		    : Oct 1, 2019
*
* @Version      : Version 1.0
*
* By            : H224423
* On            : Oct 10, 2019
* Description   : ASDS-1478 - Grid level resposnive changes and UI issue fixes
******************************************************************************/
import React from 'react';
import { Grid, Card } from '@scuf/common';

function ProductListingHeader() {
    return (
        <Grid.Row className="fullwidthRow">
            <Grid.Column width={12} className="headerBox">
                <Card className="purchaseSoftwareCard headerBoxCard">
                    <Card.Content>
                        <Grid className='productListFullWidth'>
                            <Grid.Row className="fullwidthRow">
                                <Grid.Column width={1} xsWidth={2} className= "productIcon"/>
                                <Grid.Column width={7} xsWidth={5} ><p className="product-header-name">PRODUCT NAME</p></Grid.Column>
                                <Grid.Column width={2} xsWidth={4}><p className="product-header-unit-price">UNIT PRICE</p></Grid.Column>
                                <Grid.Column width={2} xsWidth={1} />
                            </Grid.Row>
                        </Grid>
                    </Card.Content>
                </Card>
            </Grid.Column>
            {/****************Product listing header card Ends here****************/}
        </Grid.Row>
    );
}

export default ProductListingHeader;